export default "__VITE_ASSET__Bmks1FDl__"